import { IconButton } from '@chakra-ui/button';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedToggleValue } from '../../redux/canvasResolutionSlice';
import { selectedPageObject } from '../../redux/pagesSlice';
import { selectComponent } from '../../redux/selectedComponentSlice';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { findCompByIdRecursively, filterByMobileState } from '../../utils/functions';
import { UilDraggabledots } from '@iconscout/react-unicons';
import CanvasElementPlaceholder from '../canvas/CanvasElementPlaceholder';
import { isEmpty } from 'lodash';
import DebugBox from '../canvas/DebugBox';
import { Box, Text } from '@chakra-ui/layout';
import { setHoverElement } from '../../redux/hoverElementSlice';

function handleRightClick(e, selectedPageObjectValue, compProps, dispatch) {
	e.preventDefault();
	e.stopPropagation();
	const xPos = e.pageX + 'px';
	const yPos = e.pageY + 'px';
	const comp = findCompByIdRecursively(selectedPageObjectValue.pageData, compProps.componentId)?.comp;
	let childComp;
	let closest;
	if (e.ctrlKey) {
		closest = e.target.dataset.selection == compProps.componentId ? e.target : e.target.closest('[data-selection]');
		if (!closest) return selectComponent(null);
		childComp = findCompByIdRecursively(selectedPageObjectValue.pageData, closest.dataset.selection)?.comp;
	}
	dispatch(selectComponent({ props: comp ?? childComp, xPos, yPos, childComp }));
}

const RenderGroupListSA = ({ placeholderProps, imgRef, isDebugActive }) => {
	const selectedCanvasResolution = useSelector(selectedToggleValue);
	const selectedPageObjectValue = useSelector(selectedPageObject);
	const pagesData = (selectedPageObjectValue && selectedPageObjectValue.pageData) || [];
	const dispatch = useDispatch();

	const droppableBoxProps = {
		w: '100%',
		minH: '100px',
		position: 'relative',
		className: 'canvas',
	};

	const draggableBoxProps = (dragProvided, snapshot, comp) => ({
		background: snapshot.isDragging ? '#fffee6' : 'initial',
		boxShadow: snapshot.isDragging ? '0 0 6px 2pt #ecc94b' : 'initial',
		transition: '.2s',
		role: 'group',
		position: 'relative',
		overflowY: 'auto',
		ref: dragProvided.innerRef,
		className: 'DraggableBox DraggableType-' + (comp.draggableType ? comp.draggableType : 'DEFAULT'),
		...dragProvided.draggableProps,
	});

	const draggablehHandleBoxProps = {
		d: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		className: 'DraggableHandle',
		bg: '#eee',
		borderRadius: '5px',
		h: '30px',
		w: '30px',
		sx: { ':hover': { bg: '#f6e05e', cursor: 'grab' }, ':active': { bg: '#ecc94b' } },
		zIndex: 999,
		top: '12px',
		right: '12px',
		position: 'absolute',
		_groupHover: { opacity: '1', visibility: 'visible' },
		opacity: 0,
		visibility: 'hidden',
		transition: '0.1s',
	};

	function handleMouseEnter({ componentId, componentName, flag, childrenComponents }) {
		if (componentName == 'VisibilityLayout') {
			const child = childrenComponents.filter((el) => filterByMobileState(el, selectedCanvasResolution))[0];
			dispatch(
				setHoverElement({
					componentId: child.componentId,
					componentName: child.componentName,
					isCanvas: !flag,
					flag,
				}),
			);
		} else {
			dispatch(setHoverElement({ componentId, componentName, isCanvas: !flag, flag }));
		}
	}

	function handleMouseLeave() {
		dispatch(setHoverElement({ componentId: null, componentName: null }));
	}

	return (
		<>
			<Droppable droppableId={'CANVAS'} isDropDisabled={false}>
				{(provided, droppableSnapshot) => (
					<Box
						{...droppableBoxProps}
						h={isDebugActive ? '50%' : '100%'}
						{...provided.droppableProps}
						ref={provided.innerRef}
					>
						{/**Teste para o placeholder */}
						<Box position={'relative'} className="placeholder-container">
							{pagesData
								.filter((el) => filterByMobileState(el, selectedCanvasResolution))
								.map((comp, index, arr) => (
									<Draggable draggableId={comp.componentId} index={index} key={comp.componentId}>
										{(dragProvided, snapshot) => (
											<Box
												onClick={() => handleMouseEnter({ ...comp, flag: true })}
												onMouseEnter={() => handleMouseEnter(comp)}
												onMouseLeave={() => handleMouseLeave()}
												{...dragProvided.dragHandleProps}
												{...elementProps}
												{...draggableBoxProps(dragProvided, snapshot, comp)}
												onContextMenu={(e) => {
													handleRightClick(e, selectedPageObjectValue, comp, dispatch);
												}}
											>
												<Box {...elementBorder}>
													<Text {...textStyle}>
														{comp.componentGroup} - {comp.templateId ?? 1}
													</Text>
												</Box>
												<Box {...draggablehHandleBoxProps}>
													<IconButton
														key={'icon-button-0'}
														variant="outline"
														size={'sm'}
														aria-label="Mover componente"
														sx={{ cursor: 'grab' }}
														icon={<UilDraggabledots size={18} />}
													/>
												</Box>
											</Box>
										)}
									</Draggable>
								))}
							{provided.placeholder}
							{!isEmpty(placeholderProps) && droppableSnapshot.isDraggingOver && (
								<CanvasElementPlaceholder {...placeholderProps} />
							)}
						</Box>
					</Box>
				)}
			</Droppable>
			{isDebugActive ? <DebugBox /> : ''}
		</>
	);
};

export default RenderGroupListSA;

const elementProps = {
	bg: 'white',
	height: '113px',
	width: '100%',
	backgroundColor: '#fffee6',
	padding: '0px',
	d: 'flex',
	sx: { ':hover': { cursor: 'grab' } },
};

const elementBorder = {
	border: 'solid 2px #bcbcbc',
	borderRadius: '3px',
	margin: '8px 8px 5px 8px',
	w: '100%',
	verticalAlign: 'middle',
	d: 'flex',
};

const textStyle = {
	color: '#bcbcbc',
	fontWeight: 700,
	fontSize: '18px',
	alignSelf: 'center',
	margin: '0 auto',
};
